<template>
  <div id="googleCalendar">
    <div class="container">
      <h1>Google Calendar</h1>
      <form @submit.prevent class="mt-4">
        <h2>API Key</h2>
        <input
          v-model="dashboard.data.modules.googleCalendar.apiKey"
          type="text"
          class="form-control"
          placeholder="API KEY"
        >
        <h2 class="mt-4">Calendars</h2>
        <div class="form-group">
          <div
            class="row mb-1"
            v-for="(calendar, index) in calendars"
          >
            <div class="col">
              <input
                v-model="calendar.title"
                type="text"
                class="form-control"
                placeholder="Calendar title"
              >
            </div><!-- /.col -->
            <div class="col">
              <input
                v-model="calendar.id"
                type="text"
                class="form-control"
                placeholder="Calendar ID"
              >
            </div><!-- /.col -->
            <div class="col">
              <chrome-picker
                v-model="calendar.color"
                @input="checkColor()"
              />
            </div><!-- /.col -->
            <div class="col-1">
              <b-btn
                class="btn-danger"
                @click="removeCalendar(index)"
              >
                <i class="fas fa-minus"></i>
              </b-btn>
            </div><!-- /.col-1 -->
          </div><!-- /.row -->
        </div><!-- /.form-group -->
        <b-btn
          @click="addCalendar()"
        >Add Calendar</b-btn>
      </form>
      <button
        class="btn btn-primary mb-4 mt-4"
        @click="saveSettings()"
      >
        Save Settings
      </button>
    </div><!-- /.container -->
  </div><!-- /#googleCalendar -->
</template>

<script>
import { Chrome } from 'vue-color'
import { mapState } from 'vuex'
const fb = require('../../../firebaseConfig.js')

export default {
  data() {
    return {
      calendars: []
    }
  },
  computed: {
    ...mapState([
      'dashboard'
    ])
  },
  created() {
    if (this.dashboard.data.modules.googleCalendar.calendars) {
      this.calendars = this.dashboard.data.modules.googleCalendar.calendars
    }
  },
  components: {
    'chrome-picker': Chrome
  },
  methods: {
    saveSettings() {
      this.dashboard.data.modules.googleCalendar.calendars = this.calendars
      fb.dashboardsCollection.doc(this.dashboard.data.id).update({
        modules: this.dashboard.data.modules
      }).then(e => {
        const revData = this.dashboard.data
        revData.updatedOn = new Date()
        fb.dashboardRevisionsCollection.add(revData)
        alert('Successfully updated settings!')
        this.$store.commit('fetchDashboard', {id: this.$route.params.id, customStyles: false})
      }).catch(err => {
        console.log(err.message)
      })
    },
    checkColor() {
      console.log(this.calendars)
    },
    removeCalendar(index) {
      this.calendars.splice(index, 1)
    },
    addCalendar() {
      this.calendars.push({
        title: '',
        color: ''
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/modules/GoogleCalendar.vue